'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { TransactionSide } from '@marketplace-web/messaging/conversation-messaging-data'
import { HeroMessagePriceBreakdown } from '@marketplace-web/escrow-pricing/escrow-pricing-feature'
import {
  HeroMessageSellerProtection,
  useUserProtectionVisibility,
} from '@marketplace-web/seller-protection/seller-protection-feature'

interface Props {
  thumbnailUrl: string | null | undefined
}

const HeroMessageUserProtection = ({ thumbnailUrl }: Props) => {
  const { transaction } = useConversationContext()

  const isSellerBusiness = !!transaction?.seller?.business
  const sellerId = transaction?.seller?.id
  const itemsCount = transaction?.itemsCount || 0

  const isSellerProtectionVisible = useUserProtectionVisibility({
    abTestName: 'sale_is_safe_policy_in_conversation_screen',
    transactionStatus: transaction?.status,
    isSellerBusiness,
    isCorrectUserSide: transaction?.userSide === TransactionSide.Seller,
  })

  if (!transaction) return null

  if (isSellerProtectionVisible) {
    return (
      <HeroMessageSellerProtection
        transactionId={transaction.id}
        shipmentStatus={transaction.shipment?.status}
        transactionStatus={transaction?.status}
      />
    )
  }

  return (
    <HeroMessagePriceBreakdown
      thumbnailUrl={thumbnailUrl}
      itemTitle={transaction.itemTitle}
      transactionId={transaction.id}
      itemsCount={itemsCount}
      itemId={transaction.itemId}
      totalAmountWithoutTax={transaction.totalAmountWithoutTax}
      serviceFee={transaction.serviceFee}
      itemPrice={transaction.offer.price}
      sellerId={sellerId}
      isSellerBusiness={isSellerBusiness}
    />
  )
}

export default HeroMessageUserProtection
